import React from "react";
import Typography from "@material-ui/core/Typography";
import {
  CardContent,
  Divider,
  TextField,
  Chip,
  FormControl,
  InputLabel,
  NativeSelect,
  Input,
  FormHelperText
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DonateIcon from "@material-ui/icons/CardGiftcard";
import Favourite from "@material-ui/icons/FavoriteRounded";

import { fbdb } from "../AppClass";
import { LinearProgress, DialogContent } from "@material-ui/core/es";

import Script from "react-load-script";

class Payment extends React.Component {
  state = {
    payment_clicked: false,

    scriptError: false,
    scriptLoaded: false,

    money_to_donate: 5000,
    donation_success: false
  };

  payment_options = {};

  init_payment_options() {
    let self = this;

    this.payment_options = {
      key: "rzp_live_PlBeIv2kBQ0Eu9", //"rzp_test_3KtDZqIgUWhp5I",
      amount: parseInt(this.state.money_to_donate), // 2000 paise = INR 20
      name: "Aakhor",
      description: "Donate to Aakhor.",
      //image: "https://www.invisionweb.in/site/static/media/invision.2acab5b0.png",
      handler: function(response) {
        //alert(response);
        console.log(response);
        self.setState({ donation_success: true });
      },
      prefill: {
        name: "",
        email: ""
      },
      notes: {
        address: "Noonmati, Guwahati, Assam, India"
      },
      theme: {
        color: "#F1F1F1"
      }
    };
  }

  handleScriptCreate = () => {
    this.setState({ scriptLoaded: false });
  };

  handleScriptError = () => {
    this.setState({ scriptError: true });
  };

  processPayment = () => {
    if (this.state.scriptLoaded) {
      this.init_payment_options();

      var rzp1 = new window.Razorpay(this.payment_options);
      rzp1.open();
      return;
    }

    this.setState({ payment_clicked: true });
  };

  handleScriptLoad = () => {
    this.setState({ scriptLoaded: true });
    console.log("loaded");

    this.init_payment_options();

    var rzp1 = new window.Razorpay(this.payment_options);
    rzp1.open();
  };

  handleChange = e => {
    this.init_payment_options();

    this.setState({ money_to_donate: e.currentTarget.value });
  };

  render() {
    return (
      <div className="dividerMargin padding10">
        <FormControl>
          {/* <InputLabel htmlFor="amount-native-helper">Select amount to donate</InputLabel> */}
          <NativeSelect
            value={this.state.money_to_donate}
            onChange={e => {
              this.handleChange(e);
            }}
            input={<Input name="amount" id="amount-native-helper" />}
            open={this.state.payment_clicked}
          >
            <option value={5000}>₹ 50</option>
            <option value={10000}>₹ 100</option>
            <option value={50000}>₹ 500</option>
            <option value={100000}>₹ 1000</option>
          </NativeSelect>
          <FormHelperText>Select amount to donate</FormHelperText>
        </FormControl>

        <div className="dividerMargin" />

        <Button variant="outlined" onClick={() => this.processPayment()}>
          <DonateIcon style={{ marginRight: 10 }} />
          Donate
        </Button>

        {this.state.payment_clicked && (
          <Script
            url="https://checkout.razorpay.com/v1/checkout.js"
            onCreate={this.handleScriptCreate}
            onError={this.handleScriptError}
            onLoad={this.handleScriptLoad}
          />
        )}

        {this.state.donation_success && (
          <div className="dividerMargin">
            <Favourite style={{ fontSize: 60 }} color="secondary" />
            <Typography variant="h5">Thanks for donating.</Typography>
            {/* <img
            src="https://morethankyounotes.com/wp-content/uploads/2016/07/Thank-you-for-your-donation.png"
            alt="Thanks for donating"
          /> */}
          </div>
        )}
      </div>
    );
  }
}

export default Payment;
